import { render, staticRenderFns } from "./UserRate.vue?vue&type=template&id=49472c7d&scoped=true"
import script from "./UserRate.vue?vue&type=script&lang=js"
export * from "./UserRate.vue?vue&type=script&lang=js"
import style0 from "./UserRate.vue?vue&type=style&index=0&id=49472c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49472c7d",
  null
  
)

export default component.exports